export default import.meta.ROLLUP_FILE_URL_otBE4ucZUbE2cl_wFIVzQQ